import { Route, Routes } from "react-router-dom";
import { ROUTES } from "./constants";
import Home from "../screens/Home";
import Redirect from "../screens/Redirect";
import Layout from "../screens/Layout";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path={ROUTES.HOME}
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
      <Route
        path={ROUTES.LOGIN}
        element={
          <Layout>
            <Redirect />
          </Layout>
        }
      />
    </Routes>
  );
};
